module.exports = __webpack_public_path__ + "img/background-voucher-landing-desktop.d485d70.png";